import clsx from "clsx";
import styles from "./Marker.module.css";

export type MarkerVariant = "blue" | "dark" | "gray";

type MarkerProps = {
  variant?: MarkerVariant;
  className?: string;
};

export const Marker = ({ variant = "blue", className }: MarkerProps) => {
  return (
    <span
      className={clsx(styles.marker, styles[variant], className)}
      aria-hidden="true"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="6" height="6" viewBox="0 0 6 6">
        <path fill="currentColor" d="M5.938.03c-.023-.017-.104-.066-.182.017L2.355 3.69a.14.14 0 0 1-.174.028L.208 2.626c-.09-.05-.152.01-.17.03a.14.14 0 0 0-.007.184L2.29 5.896A.25.25 0 0 0 2.507 6a.25.25 0 0 0 .206-.128L5.977.22C6.04.113 5.956.043 5.938.03"/>
      </svg>
    </span>
  );
};
